import React from 'react';
import Task from './components/TaskManagement';

function App() {
  return (
      <div>
          <Task />
      </div>

  );
}
export default App;
